import Text from './text'

export type { TextProps } from './text'

export { Text }
